var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.197,
    height: 46.197,
    viewBox: "0 0 46.197 46.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "expand-solid",
    d: "M3.3,32A3.3,3.3,0,0,0,0,35.3v9.9a3.3,3.3,0,0,0,6.6,0V38.6h6.6a3.3,3.3,0,0,0,0-6.6ZM6.6,65A3.3,3.3,0,0,0,0,65v9.9a3.3,3.3,0,0,0,3.3,3.3h9.9a3.3,3.3,0,1,0,0-6.6H6.6ZM33,32a3.3,3.3,0,0,0,0,6.6h6.6v6.6a3.3,3.3,0,0,0,6.6,0V35.3A3.3,3.3,0,0,0,42.9,32ZM46.2,65a3.3,3.3,0,0,0-6.6,0v6.6H33a3.3,3.3,0,1,0,0,6.6h9.9a3.3,3.3,0,0,0,3.3-3.3Z",
    transform: "translate(0 -32)",
    fill: "#fff",
    opacity: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.e99eb6b9a7a2a2e6d76b23d238935aef.svg";
export { ForwardRef as ReactComponent };